<template>
  <div>
    <div class="avatar"
         :style="avatarStyles">
      <base-circular-loader v-if="uploading"
                            color="white"
                            size="small" />
    </div>

    <child-name :child-name="child.name"
                @changeName="changeChildName" />

    <child-avatar :child="child"
                  :uploading="uploading"
                  :default-avatars="defaultAvatars"
                  @uploadingAvatar="onAvatarUpload" />

    <child-gender :gender="child.sex"
                  @genderChange="changeChildGender" />

    <child-age :child-age="child.age"
               @changeAge="changeChildAge" />
  </div>
</template>

<script>
  import ChildName   from '@/components/Child/ChildAvatarProfilePicture/ChildName.vue'
  import ChildAvatar from '@/components/Child/ChildAvatarProfilePicture/ChildAvatar.vue'
  import ChildGender from '@/components/Child/ChildAvatarProfilePicture/ChildGender.vue'
  import ChildAge    from '@/components/Child/ChildAvatarProfilePicture/ChildAge.vue'

  import predefinedAvatars from '@/constants/predefinedAvatars.js'
  import errorNotification from '@/mixins/errorNotification.js'
  import { uploadAvatar }  from '@/services/avatar.js'
  import analytics from '@/services/analytics.js'

  export default {
    mixins: [
      errorNotification
    ],

    props: {
      childId: {
        type: String,
        required: true
      }
    },

    components: {
      ChildName,
      ChildAvatar,
      ChildGender,
      ChildAge
    },

    data() {
      return {
        uploading: false,
        defaultAvatars: predefinedAvatars,
        isSettingPrimaryDevice: false
      }
    },

    created() {
      analytics.sendEvent('EditChild_Sc')
    },

    methods: {
      onAvatarUpload(avatar) {
        this.uploading = true

        uploadAvatar(this.child.id, avatar)
          .then(() => {
            this.uploading = false
          })
          .catch(() => {
            this.failedRequestNotification()
          })
      },

      changeChildName: _.debounce(function(name) {
        if (!name) {
          return
        }

        this.updateChild({
          child_id: this.childId,
          data: {
            name
          }
        })
        .catch(() => {
          this.failedRequestNotification()
        })
      }, 500),

      changeChildGender(sex) {
        if (sex === this.child.sex) {
          return
        }

        this.updateChild({
          child_id: this.childId,
          data: {
            sex
          }
        })
        .catch(() => {
          this.failedRequestNotification()
        })
      },

      changeChildAge: _.debounce(function(age) {
        if (!age) {
          return
        }

        this.updateChild({
          child_id: this.childId,
          data: {
            age
          }
        })
        .catch(() => {
          this.failedRequestNotification()
        })
      }, 500),

      openInstalledDevices() {
        if (!this.currentUser.hasPaidLicense) {
          return
        }

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'devices'
          })

          return
        }

        this.showModal('devices')
      },

      ...mapActions('children', {
        loadChildren: 'load',
        updateChild: 'updateChild',
        removeChild: 'removeChild'
      })
    },

    computed: {
      child() {
        return this.getChildById(this.childId)
      },

      avatar() {
        return this.child.avatar_download_url
      },

      avatarId() {
        return this.child.avatar_id
      },

      avatarStyles() {
        let avatar = this.avatar || this.avatarId

        for (let key in predefinedAvatars) {
          if (this.avatarId === key) {
            avatar = predefinedAvatars[key]
          }
        }

        return {
          'background-image': 'url(' + avatar + ')',
          'background-color': '#f1f0f9',
          'background-size': 'cover',
          'background-position': 'center'
        }
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      ...mapGetters('auth', {
        currentUser: 'currentUser'
      })
    },

    beforeDestroy() {
      analytics.sendEvent('Pk_Cancel_EditCh')
    }
  }
</script>

<style lang="scss" scoped>
  .avatar {
    width: 100px;
    height: 100px;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    margin: 0 auto 20px;
  }

  .installed-devices {
    margin-bottom: 12px;
    text-align: center;
    cursor: pointer;
  }

  .remove-profile {
    text-align: center;

    .remove-btn {
      color: #fb5e55;
      margin-bottom: 14px;
      cursor: pointer;
    }

    .remove-info {
      width: 250px;
      margin: 0 auto;
      color: lighten(#3e3a3b, 30%);
    }
  }
</style>
